import React, { useState, useEffect } from "react";
import Header from "./header/Header";
import ImageResult from "./ImageResult";
import { WebcamCapture } from "./Webcam";
import imageCompression from "browser-image-compression";
import $ from "jquery";
import {
  monuments,
  dataURLToBlob,
  getDeviceType,
  backgroundRemoval,
  base64toBlob,
  deviceName,
  iOS,
  textmapping,
  doRequest,
} from "../helper";

import Pintura from "../components/Pintura";
import Popup from "../components/common/Popup";
import { NavLink, useSearchParams } from "react-router-dom";
import { CloudinaryImage } from "@cloudinary/url-gen";
import { URLConfig } from "@cloudinary/url-gen";
import { CloudConfig } from "@cloudinary/url-gen";
import { Transformation } from "@cloudinary/url-gen";
import { thumbnail, scale, crop } from "@cloudinary/url-gen/actions/resize";
import { byRadius } from "@cloudinary/url-gen/actions/roundCorners";
import { sepia } from "@cloudinary/url-gen/actions/effect";
import { source } from "@cloudinary/url-gen/actions/overlay";
import { opacity, brightness } from "@cloudinary/url-gen/actions/adjust";
import { byAngle } from "@cloudinary/url-gen/actions/rotate";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Import required qualifiers.
import { image } from "@cloudinary/url-gen/qualifiers/source";
import { Position } from "@cloudinary/url-gen/qualifiers/position";
import { compass } from "@cloudinary/url-gen/qualifiers/gravity";
import { focusOn } from "@cloudinary/url-gen/qualifiers/gravity";
import {
  advancedEyes,
  face,
  FocusOn,
} from "@cloudinary/url-gen/qualifiers/focusOn";
import { quality } from "@cloudinary/url-gen/actions/delivery";
import { ShareCountApi } from "../helper";
import CropperComponent from "./common/Cropper";
import UploadedImage from "./common/UploadedImage";
import ErrorPopup from "./ErrorPopup";
var EXIF = require("exif-js/exif.js");

const CloudName = "opalina-technologies";

function SliderArrowNext(props) {
  const { className, onClick, style } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        background: "url('../assets/images/arrowright.svg') no-repeat",
        content: " ",
        backgroundSize: "100%",
        width: "40px",
        height: "40px",
        zIndex: "99",
        right: "-10px",
      }}
    ></div>
  );
}

function SliderArrowPrev(props) {
  const { className, onClick, style } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        ...style,
        background: "url('../assets/images/arrowleft.svg') no-repeat",
        content: " ",
        backgroundSize: "100%",
        width: "40px",
        height: "40px",
        zIndex: "99",
      }}
    ></div>
  );
}

const UploadImage = (props) => {
  const [acriveEffect, setActiveEffectIndex] = useState(null);
  const [acriveObj, setActiveEffectobj] = useState({});
  const [camera, setCamera] = useState(false);
  const [activemonument, setActiveMonumentIndex] = useState(null);
  const [acriveObjM, setActiveMonumentobj] = useState({});
  const [CloudImg, setCloudImg] = useState("");
  const [CloudTitle, setCloudTitle] = useState("");
  const [Checkbox, SetCheckbox] = useState("MyGov");
  const [CheckAmrit, SetCheckAmritbox] = useState("Amrit");
  const [userImage, setUserImage] = useState("");
  const [cropModal, setCropModal] = useState(false);
  const [pintura, setPintura] = useState(false);
  const [userImageforpintura, setUserImagePintura] = useState(false);
  const [selectImage, setSelectImage] = useState("");
  const [croppedFile, setcroppedFile] = useState(false);
  const [inputFile, setInputFile] = useState("");
  const [imageId, setImageId] = useState("");
  const [imageDate, setImageDate] = useState("");
  const [imageDownloadUrl, setImageDownloadUrl] = useState("");
  const [activeEffects, setActiveEffects] = useState(false);
  const [activeMonuments, setActiveMonuments] = useState(false);
  const [downloadImageFormat, setDownloadImageFormat] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [effectType, setEffectType] = useState("");
  const [selectedInput, setSelectdInput] = useState("");
  const [filename, setFileName] = useState("");
  const [finalResultAry, setfinalResultAry] = useState([]);
  const [guidLinePopup, setGuidLinePopup] = useState(true);
  const [cameraPermissionGranted, setCameraPermissionGranted] = useState(false);
  const [showCameraError, setShowCameraError] = useState(false);

  const [searchParams] = useSearchParams();
  const userid = searchParams.get("userid");

  // console.log("new data", Checkbox);
  // console.log("new amrit", CheckAmrit);

  var monument = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.2,
    slidesToScroll: 3,
    autoplay: false,
    arrows: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 2,
          infinite: false,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  const EffectAry = [
    {
      img: "/assets/images/img-21.jpg",
      Effectimg: "/assets/images/flagpaint.png",
      effect_id: "15Aug:Asset_2_i4ckrz",
      effect_id_with_logo: "15Aug:flagpainttop_fih1x8",
      type: "facepaint",
      name: "Flag Face Paint",
    },
    {
      img: "/assets/images/img-21.jpg",
      Effectimg: "/assets/images/vectorflag.png",
      effect_id: "15Aug:vectorflag2_mvzgmz",
      effect_id_with_logo: "15Aug:vectorflagtop_hxfz0s",
      name: "Vector Flag",
    },
    {
      img: "/assets/images/img-21.jpg",
      Effectimg: "/assets/images/flaggradient.png",
      effect_id: "15Aug:flaggradient2_juj2gv",
      effect_id_with_logo: "15Aug:flaggradienttop_zw3gsx",
      name: "Flag Color Gradient",
    },
    {
      img: "/assets/images/img-21.jpg",
      Effectimg: "/assets/images/colorpaint.png",
      effect_id: "15Aug:colorpaint2_xqjsd4",
      effect_id_with_logo: "15Aug:colorpainttop_vquxmv",
      name: "Flag Color Vectors",
    },
  ];

  const setActiveEffect = (index, obj) => {
    console.log("index is ", index, " and obj is ", obj);
    if (index != acriveEffect) {
      $(".effectcl").removeClass("active");
      setTimeout(() => {
        $(".effectcl_" + index).addClass("active");
        setActiveEffects(true);
      }, 100);
      setActiveEffectIndex(index);
      setActiveEffectobj(obj);
    }
  };

  const setActiveMonument = (index, obj) => {
    if (index != activemonument) {
      $(".monumentcl").removeClass("active");
      setTimeout(() => {
        $(".monumentcl_" + index).addClass("active");
        setActiveMonuments(true);
      }, 100);
      setActiveMonumentIndex(index);
      setActiveMonumentobj(obj);
    }
  };

  const upoadFile = async (file, noprogress) => {
    let form = new FormData();
    form.append("file", file);
    form.append("upload_preset", "hamara_sankalp_viksit_bharat");

    $(".progress_div").show();

    let settings = {
      url: "https://api.cloudinary.com/v1_1/" + CloudName + "/upload",
      method: "POST",
      timeout: 0,
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
      xhr: function () {
        let xhr = new window.XMLHttpRequest();
        xhr.upload.addEventListener(
          "progress",
          function (evt) {
            if (evt.lengthComputable) {
              if (!noprogress) {
                let percentComplete = evt.loaded / evt.total;
                percentComplete = parseInt(percentComplete * 100);
                $(".progress_custom").text(percentComplete + "%");
                $("#progressBar").css("width", percentComplete + "%");
              }
            }
          },
          false
        );
        return xhr;
      },
    };

    let request = await $.ajax(settings);
    // console.log("upload api response ", request.url);
    return request;
  };

  const readFile = async (e) => {
    setEffectType("Effect");
    if (!acriveEffect) {
      alert("Please select an effect to proceed.");
      return false;
    }

    $(".upload_div").hide();

    var input = e.target;

    let image = input.files[0];
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    const compressedFile = await imageCompression(image, options);
    // console.log("compressedfile", compressedFile);
    var element = new File([compressedFile], compressedFile.name, {
      lastModified: compressedFile.lastModified,
      type: image.type,
    });
    console.log(element, "in");
    setInputFile(input);
    setcroppedFile(false);
    e.persist();

    // console.log("input files ", input.files);

    if (element) {
      const files = element;
      setSelectdInput(files);

      if (files) {
        setFileName(files.name);
        // const fileReader = new FileReader();
        // fileReader.readAsDataURL(files);
        // fileReader.addEventListener("load", function () {
        //     let result = this.result;
        //     setSelectImage(result)
        //     setCropModal(true)
        // });
        // let res = await upoadFile(files);
        // console.log(res, "resres");
        // let userimg_id = JSON.parse(res).public_id;

        // if (!acriveObj.type) {
        //   $(".preloader_bg").show();
        //   let res = await upoadFile(files);
        //   console.log(res, "resres");
        //   let userimg_id = JSON.parse(res).public_id;

        //   let url =
        //     "https://res.cloudinary.com/" +
        //     CloudName +
        //     "/image/upload/c_thumb,g_face,h_1200,w_1200/l_v1659699483:" +
        //     (CheckAmrit ? acriveObj.effect_id_with_logo : acriveObj.effect_id) +
        //     "/c_scale,h_1200,w_1200/fl_layer_apply/q_100/" +
        //     userimg_id +
        //     "?_a=AJCihWI0";
        //   let title = acriveObj.name;
        //   setUserImage(url);
        //   setCloudImg(url);
        //   setCloudTitle(title);
        //   saveImage(url, title, "Effects");
        // //   $(".preloader_bg").hide();
        // } else {
        // const fileReader = new FileReader();
        // // fileReader.readAsDataURL(files);
        // fileReader.addEventListener("load", function () {
        //   let result = this.result;

        //   var image = new Image();
        //   var input_src = this.result;

        //   console.log("image loading");
        //   image.onload = function (imageEvent) {
        //     console.log("image loaded");
        //     var orientation_do = 0;
        //     console.log('exif ', EXIF)
        //     EXIF.getData(image, function () {
        //       console.log("exit condition");
        //       console.log('exif image ', image)
        //       var orientation = EXIF.getTag(this, "Orientation");
        //       console.log('orientation', orientation)
        //       if (typeof orientation !== "undefined") {
        //         orientation_do = orientation;
        //       }
        //     });

        //     // Resize the image
        //     var canvas = document.createElement("canvas"),
        //       max_size = 1200, // TODO : pull max size from a site config
        //       width = image.width,
        //       height = image.height;
        //     if (width > height) {
        //       if (width > max_size) {
        //         height *= max_size / width;
        //         width = max_size;
        //       }
        //     } else {
        //       if (height > max_size) {
        //         width *= max_size / height;
        //         height = max_size;
        //       }
        //     }
        //     // alert(orientation_do);
        //     // if ((orientation_do == 6 || orientation_do == 8)) { //iphone fixed their bug
        //     if (orientation_do === 8) {
        //       //iphone fixed their bug
        //       canvas.width = height;
        //       canvas.height = width;
        //     } else {
        //       canvas.width = width;
        //       canvas.height = height;
        //     }

        //     var ctx = canvas.getContext("2d");

        //     // context.clearRect( 0, 0, canvas.width, canvas.height );

        //     ctx.drawImage(image, 0, 0, width, height);

        //     var dataUrl = canvas.toDataURL("image/jpeg");
        //     console.log("data url ", dataUrl);

        //     $('.cropper-container').css('transform', 'rotate(90deg)')
        //     var resizedImage = dataURLToBlob(dataUrl);

        //     console.log("image ", resizedImage);
        //     setSelectImage(dataUrl);
        //     setCropModal(true);
        //   };
        //   image.src = input_src;

        //   // setSelectImage(result);
        // });
        // fileReader.readAsDataURL(files);

        const fileReader = new FileReader();
        fileReader.readAsDataURL(files);
        fileReader.addEventListener("load", function () {
          let ios = iOS();

          let result = this.result;
          if (!ios) {
            setSelectImage(result);
            setCropModal(true);
          } else {
            setShowModal(true);
            setSelectedImage(result);
          }
        });

        // createFacePaint(userimg_id);
        // }
      }
    }
  };
  var _URL = window.URL || window.webkitURL;

  const readFile1 = async (e) => {
    setEffectType("Monuments");
    var img;
    // if (!activemonument) {
    //   alert("Please select a monument to proceed.");
    //   return false;
    // }

    let file = e.target.files;
    file = file[0];
    let image = file;
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    $(".preloader_bg").show();
    const compressedFile = await imageCompression(image, options);
    // console.log("compressedfile", compressedFile);
    file = new File([compressedFile], compressedFile.name, {
      lastModified: compressedFile.lastModified,
      type: image.type,
    });
    setSelectdInput(file);
    setFileName(file.name);

    if (file) {
      console.log("file is ", file);

      if (
        file.type != "image/jpeg" &&
        file.type != "image/png" &&
        file.type != "image/jpg"
      ) {
        $(".error_popupbg").show();
        $(".textp").text(
          textmapping("Please select a jpg, jpeg and png image", props.lang)
        );
        return;
      }
      $(".upload_div").hide();
      const fileReader = new FileReader();
      // fileReader.readAsDataURL(file);
      fileReader.readAsDataURL(file);
      fileReader.addEventListener("load", function () {
        let ios = iOS();

        let result = this.result;

        if (!ios) {
          setSelectImage(result);
          setCropModal(true);
        } else {
          setShowModal(true);
          setSelectedImage(result);
        }
        $(".preloader_bg").hide();
      });

      // let result = this.result;
      // setSelectImage(result);
      // setCropModal(true);
    }

    // console.log(file, "filefilefile..");

    // window.location = blobUrl;
  };

  const handleUpload1 = async (myFile, image) => {
    setEffectType("Monuments");
    if (!activemonument) {
      alert("Please select a monument to proceed.");
      return false;
    }

    setCamera(false);
    $(".upload_div").hide();

    let file = myFile;
    setFileName(file.name);
    setSelectdInput(file);

    if (file) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.addEventListener("load", function () {
        let ios = iOS();
        let result = this.result;
        if (!ios) {
          setSelectImage(result);
          setCropModal(true);
        } else {
          setShowModal(true);
          setSelectedImage(result);
        }
      });
    }

    // console.log(file, "filefilefile..");
    // var requestOptions = {
    //   method: "GET",
    //   redirect: "follow",
    // };

    // let res = await upoadFile(file);

    // let url = JSON.parse(res).url;
    // let newURL =
    //   "https://res.cloudinary.com/ds4uvg1mz/image/upload/c_thumb,g_face,w_450/fl_getinfo/" +
    //   JSON.parse(res).public_id;
    // console.log(url);

    // let sk = await fetch(newURL, requestOptions);

    // let jsonss = await sk.json();

    // let inputImage = jsonss.input;
    // console.log(inputImage, "inputImageinputImage");
    // if (inputImage.height > "4096" || inputImage.width > "4096") {
    //   url =
    //     "https://res.cloudinary.com/ds4uvg1mz/image/upload/c_thumb,g_face,h_1200,w_1200/" +
    //     JSON.parse(res).public_id;
    // }
    // // return false;

    // // let res = await upoadFile(file);

    // // let url = JSON.parse(res).url;

    // $(".preloader_bg").show();

    // let json = await backgroundRemoval(url);

    // let b64Data = "data:image/png;base64," + json.results[0].entities[0].image;

    // let resizedImage = dataURLToBlob(b64Data);
    // let filenew = new File([resizedImage], "sample.png");
    // console.log(filenew, "filenewfilenew...");

    // let newres = await upoadFile(b64Data, "noprogress");

    // let userimg_id = JSON.parse(newres).public_id;
    // console.log(userimg_id);

    // let newurl =
    //   "https://res.cloudinary.com/" +
    //   CloudName +
    //   "/image/upload/l_" +
    //   userimg_id.split("/").join(":") +
    //   // "/c_scale,fl_region_relative,w_0.5/fl_layer_apply,g_south/" + (CheckAmrit ? 'l_v1659857208:15Aug:flagpainttop_fih1x8.png/c_scale,h_500,w_1200/fl_layer_apply,g_north/' : '') + "c_scale,h_1200,w_1200/q_100/" +
    //   "/c_scale,fl_region_relative,w_0.5/fl_layer_apply,g_south/c_scale,h_1200,w_1200/q_100/" +
    //   (CheckAmrit ? acriveObjM.imgIdWithlogo : acriveObjM.imgId) +
    //   "?_a=AJCihWI0";
    // let newtitle = "Monuments";
    // setCloudImg(newurl);
    // setCloudTitle(newtitle);
    // saveImage(newurl, newtitle, newtitle);
    // $(".preloader_bg").hide();
  };

  const getland = async (userimg_id) => {
    var settings = {
      url:
        "https://res.cloudinary.com/" +
        CloudName +
        "/image/upload/c_thumb,g_face,w_450/fl_getinfo/v1/" +
        userimg_id,
      method: "GET",
      timeout: 0,
    };

    let data = await $.ajax(settings).done(function (response) {
      // console.log(response);
    });

    return data;
  };

  let saveImage = async (url, title, type, meta_image) => {
    let localData = JSON.parse(localStorage.getItem("user_details"));
    let name = props.lang == "gu" ? acriveObjM["name_gu"] : acriveObjM["name"];
    let img = props.lang == "gu" ? acriveObjM["imgId_gu"] : acriveObjM["imgId"];

    let data = {
      post_url: url,
      user_id: localData.user_id ? localData.user_id : "",
      city: localData.city_name,
      state: localData.state_name,
      post_type: title,
      frame_img: img,
      meta_image: meta_image ? meta_image : "",
      effect_name: name,
    };

    try {
      window.gtag("event", "Selfie Created Successfully", data);
    } catch (error) {}

    let response = await doRequest(data, "POST", "post/create");
    return response;
  };

  const createFacePaint = async (userimg_id, imageFormat) => {
    setEffectType("Effect");
    let cloudConfig = new CloudConfig({
      cloudName: CloudName,
      apiKey: "414576947869597",
      apiSecret: "A2yfgs0BYzSyKYGw0d5-XvvUJHE",
    });
    let urlConfig = new URLConfig({ secure: true });

    // Instantiate and configure a CloudinaryImage object.
    let myImage = new CloudinaryImage(
      userimg_id,
      cloudConfig,
      urlConfig
    ).delivery(quality(100));
    let myImage1 = new CloudinaryImage(
      userimg_id,
      cloudConfig,
      urlConfig
    ).delivery(quality(100));
    let myImage2 = new CloudinaryImage(
      userimg_id,
      cloudConfig,
      urlConfig
    ).delivery(quality(100));

    let res = await getland(userimg_id);
    let landmarks = res.landmarks[0][0];
    let l_eye = landmarks.l_eye;
    let nose_tip = landmarks.nose_tip;
    let r_eye = landmarks.r_eye;
    let iwidth = res.input.width;
    let iheight = res.input.height;
    let width = res.output.width;
    let widthoverlayim = 40;
    let half = widthoverlayim / 2;
    half = parseInt(half);
    let thee = widthoverlayim / 3;
    thee = parseInt(thee);

    var a = l_eye.x - r_eye.x;
    var b = l_eye.y - r_eye.y;

    var distance = Math.sqrt(a * a + b * b);

    let flag_width = parseInt(distance / 2.5);
    let flag_height = parseInt(flag_width / 1.4);

    let xminus = parseInt(flag_width / 2);
    let yminus = parseInt(flag_width / 3);

    let finalResult = [];

    let result = paint(
      myImage,
      flag_width,
      flag_height,
      l_eye,
      r_eye,
      xminus,
      yminus,
      iwidth,
      iheight
    );

    setCloudImg(result);

    // CheckAmrit
    //   ? myImage
    //     .overlay(
    //       source(
    //         image("15Aug/Asset_2_i4ckrz").transformation(
    //           new Transformation()
    //             .resize(crop().gravity(focusOn(face())))
    //             .resize(scale().width(flag_width).height(flag_height))
    //         )
    //       ).position(
    //         new Position()
    //           .gravity(compass("north_west"))
    //           .offsetX(l_eye.x - xminus)
    //           .offsetY(l_eye.y - yminus + flag_width)
    //       )
    //     )
    //     .overlay(
    //       source(
    //         image("15Aug/Asset_2_i4ckrz").transformation(
    //           new Transformation()
    //             .resize(crop().gravity(focusOn(face())))
    //             .resize(scale().width(flag_width).height(flag_height))
    //         )
    //       ).position(
    //         new Position()
    //           .gravity(compass("north_west"))
    //           .offsetX(r_eye.x - xminus)
    //           .offsetY(r_eye.y - yminus + flag_width)
    //       )
    //     )
    //     .overlay(
    //       source(
    //         image("v1659857208/15Aug/flagpainttop_fih1x8.png").transformation(
    //           new Transformation().resize(
    //             scale()
    //               .width(iwidth)
    //               .height(parseInt(iheight / 1.5))
    //           )
    //         )
    //       ).position(new Position().gravity(compass("north")))
    //     )
    //     .resize(scale().width(600).height(600))
    //   : myImage
    //     .overlay(
    //       source(
    //         image("15Aug/Asset_2_i4ckrz").transformation(
    //           new Transformation()
    //             .resize(crop().gravity(focusOn(face())))
    //             .resize(scale().width(flag_width).height(flag_height))
    //         )
    //       ).position(
    //         new Position()
    //           .gravity(compass("north_west"))
    //           .offsetX(l_eye.x - xminus)
    //           .offsetY(l_eye.y - yminus + xminus)
    //       )
    //     )
    //     .overlay(
    //       source(
    //         image("15Aug/Asset_2_i4ckrz").transformation(
    //           new Transformation()
    //             .resize(crop().gravity(focusOn(face())))
    //             .resize(scale().width(flag_width).height(flag_height))
    //         )
    //       ).position(
    //         new Position()
    //           .gravity(compass("north_west"))
    //           .offsetX(r_eye.x - xminus)
    //           .offsetY(r_eye.y - yminus + xminus)
    //       )
    //     )
    //     .resize(scale().width(600).height(600));

    // const myURL = myImage.toURL();
    // let downloadUrl1 = result.split("?")[0];
    setUserImage(result);
    // setImageDownloadUrl(`${downloadUrl1}.${imageFormat}`);

    let meta_image = result.replace("h_600", "h_400");

    let downloadUrl = result.split("?")[0];

    setImageDownloadUrl(`${downloadUrl}.${imageFormat}`);

    let response = await saveImage(
      result,
      acriveObj.name,
      "Effect",
      meta_image
    );

    setImageId(response.response.id);
    setImageDate(response.response.created_at);

    finalResult.push({
      image: result,
      downloadUrl: `${downloadUrl}.${imageFormat}`,
      id: response.id,
      created: response.response.created_at,
    });

    let result1 = paint(
      myImage1,
      flag_width,
      flag_height,
      l_eye,
      r_eye,
      xminus,
      yminus,
      iwidth,
      iheight,
      yminus
    );

    let downloadUrl1 = result1.split("?")[0];
    // setUserImage(result);
    // setImageDownloadUrl(`${downloadUrl1}.${imageFormat}`);

    let meta_image1 = result1.replace("h_600", "h_400");

    // let downloadUrl1 = result.split("?")[0];

    // setImageDownloadUrl(`${downloadUrl}.${imageFormat}`);

    let response1 = await saveImage(
      result1,
      acriveObj.name,
      "Effect",
      meta_image1
    );

    finalResult.push({
      image: result1,
      downloadUrl: `${downloadUrl1}.${imageFormat}`,
      id: response1.response.id,
      created: response1.response.created_at,
    });

    let result2 = paint(
      myImage2,
      flag_width,
      flag_height,
      l_eye,
      r_eye,
      xminus,
      yminus,
      iwidth,
      iheight,
      yminus + yminus
    );

    let downloadUrl2 = result2.split("?")[0];
    // setUserImage(result);
    // setImageDownloadUrl(`${downloadUrl1}.${imageFormat}`);

    let meta_image2 = result2.replace("h_600", "h_400");

    // let downloadUrl1 = result.split("?")[0];

    // setImageDownloadUrl(`${downloadUrl}.${imageFormat}`);

    let response2 = await saveImage(
      result2,
      acriveObj.name,
      "Effect",
      meta_image2
    );

    finalResult.push({
      image: result2,
      downloadUrl: `${downloadUrl2}.${imageFormat}`,
      id: response2.response.id,
      created: response2.response.created_at,
    });
    setfinalResultAry(finalResult);
    setCloudImg(result);
    $(".preloader_bg").hide();
  };

  const paint = (
    myImage,
    flag_width,
    flag_height,
    l_eye,
    r_eye,
    xminus,
    yminus,
    iwidth,
    iheight,
    extra
  ) => {
    CheckAmrit
      ? myImage
          .overlay(
            source(
              image("15Aug/Asset_2_i4ckrz").transformation(
                new Transformation()
                  .resize(crop().gravity(focusOn(face())))
                  .resize(scale().width(flag_width).height(flag_height))
              )
            ).position(
              new Position()
                .gravity(compass("north_west"))
                .offsetX(extra ? l_eye.x - xminus + extra : l_eye.x - xminus)
                .offsetY(l_eye.y - yminus + flag_width)
            )
          )
          .overlay(
            source(
              image("15Aug/Asset_2_i4ckrz").transformation(
                new Transformation()
                  .resize(crop().gravity(focusOn(face())))
                  .resize(scale().width(flag_width).height(flag_height))
              )
            ).position(
              new Position()
                .gravity(compass("north_west"))
                .offsetX(extra ? r_eye.x - xminus - extra : r_eye.x - xminus)
                .offsetY(r_eye.y - yminus + flag_width)
            )
          )
          .overlay(
            source(
              image("v1659857208/15Aug/flagpainttop_fih1x8.png").transformation(
                new Transformation().resize(
                  scale()
                    .width(iwidth)
                    .height(parseInt(iheight / 1.5))
                )
              )
            ).position(new Position().gravity(compass("north")))
          )
          .resize(scale().width(600).height(600))
      : myImage
          .overlay(
            source(
              image("15Aug/Asset_2_i4ckrz").transformation(
                new Transformation()
                  .resize(crop().gravity(focusOn(face())))
                  .resize(scale().width(flag_width).height(flag_height))
              )
            ).position(
              new Position()
                .gravity(compass("north_west"))
                .offsetX(extra ? l_eye.x - xminus + extra : l_eye.x - xminus)
                .offsetY(l_eye.y - yminus + xminus)
            )
          )
          .overlay(
            source(
              image("15Aug/Asset_2_i4ckrz").transformation(
                new Transformation()
                  .resize(crop().gravity(focusOn(face())))
                  .resize(scale().width(flag_width).height(flag_height))
              )
            ).position(
              new Position()
                .gravity(compass("north_west"))
                .offsetX(extra ? r_eye.x - xminus - extra : r_eye.x - xminus)
                .offsetY(r_eye.y - yminus + xminus)
            )
          )
          .resize(scale().width(600).height(600));

    // let ary = []

    const myURL1 = myImage.toURL();
    return myURL1;
  };

  const Backbutton = () => {
    setCloudImg(null);
    setTimeout(() => {
      $(".effectcl_" + acriveEffect).addClass("active");
      $(".monumentcl_" + activemonument).addClass("active");
    }, 100);
  };

  const Next = async () => {
    let json = await backgroundRemoval(userImage);

    let b64Data = "data:image/png;base64," + json.results[0].entities[0].image;

    // let image = new Image();
    // image.src = b64Data;
    // document.body.appendChild(image);

    let resizedImage = dataURLToBlob(b64Data);
    let d = new Date();
    let filenew = new File([resizedImage], "sample_" + d + ".png");

    let newres = await upoadFile(b64Data);

    let userimg_id = JSON.parse(newres).public_id;

    let newurl =
      "https://res.cloudinary.com/" +
      CloudName +
      "/image/upload/l_" +
      userimg_id.split("/").join(":") +
      "/c_scale,fl_region_relative,w_0.5/fl_layer_apply,g_south/c_scale,h_1200,w_1200/q_100/" +
      acriveObjM.imgId +
      "?_a=AJCihWI0";
    let newtitle = "Monuments";
    setCloudImg(newurl);
    let meta_image = newurl.split("h_1200");
    meta_image = meta_image.join("h_400");
    meta_image = meta_image.replace("w_1200", "w_650");
    saveImage(newurl, newtitle, newtitle, meta_image);
    setCloudTitle(newtitle);
  };
  const handleUpload = async (myFile, imageurl) => {
    setEffectType("Effect");
    setCamera(false);

    if (!acriveEffect) {
      alert("Please select an effect to proceed.");
      return false;
    }

    $(".upload_div").hide();

    // let input = myFile;
    let file = myFile;

    // setInputFile(input);
    // setcroppedFile(false);
    // e.persist();

    // console.log("input files ", input.files);

    if (file) {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.addEventListener("load", function () {
        let result = this.result;
        setSelectImage(result);
        setCropModal(true);
      });
    }

    // let res = await upoadFile(file);
    // $(".preloader_bg").show();
    // console.log(res, "resres");
    // let userimg_id = JSON.parse(res).public_id;

    // if (!acriveObj.type) {
    //   let url =
    //     "https://res.cloudinary.com/" +
    //     CloudName +
    //     "/image/upload/c_thumb,g_face,h_1200,w_1200/l_v1659699483:" +
    //     (CheckAmrit ? acriveObj.effect_id_with_logo : acriveObj.effect_id) +
    //     "/c_scale,h_1200,w_1200/fl_layer_apply/q_100/" +
    //     userimg_id +
    //     "?_a=AJCihWI0";
    //   let title = acriveObj.name;
    //   setUserImage(url);
    //   setCloudImg(url);
    //   setCloudTitle(title);
    //   saveImage(url, title, title);
    //   $(".preloader_bg").hide();
    // } else {
    //   // const fileReader = new FileReader();
    //   // fileReader.readAsDataURL(file);
    //   // fileReader.addEventListener("load", function () {
    //   //     let result = this.result;
    //   //     setSelectImage(result);
    //   //     setCropModal(true);
    //   // });
    //   createFacePaint(userimg_id);
    // }
  };

  const closeCropper = () => {
    setCropModal(false);
  };

  const getCroppedImage = async (croppedimage) => {
    // console.log("cropped image is ", croppedimage);
    setcroppedFile(true);
    setSelectImage(croppedimage);
    setCropModal(false);
    $(".preloader_bg").show();
    let res = await upoadFile(croppedimage);
    // console.log(res, "resres");
    let userimg_id = JSON.parse(res).public_id;
    let imageUrl = JSON.parse(res).url;
    let imageFormat = JSON.parse(res).format;
    setDownloadImageFormat(imageFormat);

    if (!acriveObj.type) {
      let url =
        "https://res.cloudinary.com/" +
        CloudName +
        "/image/upload/c_thumb,g_face,h_1200,w_1200/l_v1659699483:" +
        (CheckAmrit ? acriveObj.effect_id_with_logo : acriveObj.effect_id) +
        "/c_scale,h_1200,w_1200/fl_layer_apply/q_100/" +
        userimg_id +
        "?_a=AJCihWI0";

      let downloadurl = url.split("?")[0];

      setImageDownloadUrl(`${downloadurl}.${imageFormat}`);
      let finalResult = [];

      let title = acriveObj.name;
      setUserImage(url);
      setCloudImg(url);
      setCloudTitle(title);
      let meta_image = url.split("h_1200");
      meta_image = meta_image.join("h_400");
      meta_image = meta_image.split("w_1200");
      meta_image = meta_image.join("w_650");
      let response2 = await saveImage(url, title, "Effects", meta_image);

      finalResult.push({
        image: url,
        downloadUrl: `${downloadurl}.${imageFormat}`,
        id: response2.response.id,
        created: response2.response.created_at,
      });
      setfinalResultAry(finalResult);
      $(".preloader_bg").hide();
    } else {
      createFacePaint(userimg_id, imageFormat);
    }
  };

  const getMonumentCropped = async (croppedimage) => {
    setcroppedFile(true);
    setSelectImage(croppedimage);
    setCropModal(false);
    $(".preloader_bg").show();

    var resizedImage = dataURLToBlob(croppedimage);
    var date = new Date();

    let file = new File([resizedImage], filename);

    // return false;

    // var requestOptions = {
    //   method: "GET",
    //   redirect: "follow",
    // };
    // let res = await upoadFile(croppedimage);

    // let url = JSON.parse(res).url;
    // let imageFormat = JSON.parse(res).format;
    // setDownloadImageFormat(imageFormat);
    // let newURL =
    //   "https://res.cloudinary.com/ds4uvg1mz/image/upload/c_thumb,g_face,w_450/fl_getinfo/" +
    //   JSON.parse(res).public_id;
    // // console.log(url);

    // let sk = await fetch(newURL, requestOptions);

    // let jsonss = await sk.json();

    // let inputImage = jsonss.input;
    // // console.log(inputImage, "inputImageinputImage");
    // if (inputImage.height > "4096" || inputImage.width > "4096") {
    //   url =
    //     "https://res.cloudinary.com/ds4uvg1mz/image/upload/c_thumb,g_face,h_1200,w_1200/" +
    //     JSON.parse(res).public_id;
    // }
    // return false;

    // let res = await upoadFile(file);

    // let url = JSON.parse(res).url;

    let newres = await backgroundRemoval(file);

    if (newres) {
      // console.log("response ", json);

      // if (json.results[0].status["code"] === "failure") {
      //   alert(
      //     "Image size is too big. Please upload your image again. Maximum allowed resolution is 4096*4096"
      //   );
      //   $(".preloader_bg").hide();
      //   $(".progress_div").hide();
      //   $(".upload_div").show();
      //   $(".progress_custom").text("0%");
      //   $("#progressBar").css("width", "0%");
      //   setCloudImg(null);
      //   setTimeout(() => {
      //     $(".effectcl_" + acriveEffect).addClass("active");
      //     $(".monumentcl_" + activemonument).addClass("active");
      //   }, 100);
      //   return "";
      // } else {

      // var data = {
      //   action: "update",
      //   data: {
      //     id: 5748998420,
      //     created: "1",
      //   },
      // };
      // await ShareCountApi(data);
      // console.log(res.data.message);
      // }

      // let b64Data = "data:image/png;base64," + json.results[0].entities[0].image;

      // let image = new Image();
      // image.src = b64Data;
      // document.body.appendChild(image);

      // let resizedImage = dataURLToBlob(b64Data);
      // let filenew = new File([resizedImage], "sample.png");
      // console.log(filenew, "filenewfilenew...");

      // let newres = await upoadFile(b64Data, "noprogress");

      let userimg_id = newres.public_id;
      // console.log(userimg_id);
      // let imageFormat = newres.format;
      $(".preloader_bg").hide();

      setPintura(true);
      setUserImagePintura(newres);
    } else {
      $(".preloader_bg").hide();
      alert("Somthing went wrong.");
    }

    return false;

    // let newurl =
    //   "https://res.cloudinary.com/" +
    //   CloudName +
    //   "/image/upload/l_" +
    //   userimg_id.split("/").join(":") +
    //   // "/c_scale,fl_region_relative,w_0.5/fl_layer_apply,g_south/" + (CheckAmrit ? 'l_v1659857208:15Aug:flagpainttop_fih1x8.png/c_scale,h_500,w_1200/fl_layer_apply,g_north/' : '') + "c_scale,h_1200,w_1200/q_100/" +
    //   "/c_scale,fl_region_relative,w_0.5/fl_layer_apply," +
    //   (acriveObjM.right ? "g_south_east" : "g_south") +
    //   "/c_scale,h_1200,w_1200/q_100/" +
    //   (CheckAmrit ? acriveObjM.imgIdWithlogo : acriveObjM.imgId) +
    //   "?_a=AJCihWI0";

    // let downloadurl = newurl.split("?")[0];
    // console.log("download url ", downloadurl);
    // setImageDownloadUrl(`${downloadurl}`);
    // let newtitle = "Monuments";
    // setCloudImg(newurl);
    // setCloudTitle(newtitle);
    // let meta_image = newurl.split("h_1200");
    // meta_image = meta_image.join("h_400");
    // meta_image = meta_image.replace("w_1200", "w_600");
    // let response2 = await saveImage(newurl, newtitle, newtitle, meta_image);
    // let finalResult = [];

    // finalResult.push({
    //   image: newurl,
    //   downloadUrl: downloadurl,
    //   id: response2.id,
    //   created: response2.data.created,
    // });

    // setfinalResultAry(finalResult);
    // $(".preloader_bg").hide();
  };

  const closeModal = () => {
    setShowModal(false);
    $(".upload_div").show();
  };

  const getFinalPintura = async (file) => {
    $(".preloader_bg").show();
    let res = await upoadFile(file);

    let url = JSON.parse(res).url;

    let downloadurl = url;
    setImageDownloadUrl(url);
    let newtitle = "Monuments";
    setCloudImg(url);
    setCloudTitle(newtitle);
    let meta_image = url.split("upload/").join("upload/c_scale,h_630,w_1200/");
    let response2 = await saveImage(url, newtitle, newtitle, meta_image);
    let finalResult = [];

    finalResult.push({
      image: url,
      downloadUrl: downloadurl,
      id: response2.response.id,
      // created: response2.data.created,
    });
    setfinalResultAry(finalResult);
    $(".preloader_bg").hide();

    setPintura(false);
  };

  const rotateImage = async (image, degree) => {
    var formdata = new FormData();
    // formdata.append(
    //   "file",
    //   fileInput.files[0],
    //   "/C:/Users/DeepakKumar/Downloads/9k= (3).png"
    // );
    formdata.append("file", image);
    formdata.append("direction", `${degree}`);

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    let res = await fetch(
      // "https://api.mydkscore.com/api/rotate-image",
      "https://api.modistory.in/v1/articlecategory/rotate-image",
      requestOptions
    );
    res = await res.json();
    if (res.result === 1) {
      return res.data.secure_url;
    } else {
      return res.message;
    }
  };

  const showCropper = (image) => {
    setCropModal(true);
    setSelectImage(image);
  };

  const closeGuidLinePopup = () => {
    setGuidLinePopup(false);
  };

  useEffect(() => {
    if (monuments?.length > 0) {
      setActiveMonument("0", monuments[0]);
    }
  }, [monuments]);

  useEffect(() => {
    try {
      navigator.permissions
        .query({ name: "camera" })
        .then(function (cameraPermissionStatus) {
          if (cameraPermissionStatus.state === "granted") {
            // Camera permission has already been granted
            console.log("granted state");
            setCameraPermissionGranted(true);
            setShowCameraError(false);
          } else if (cameraPermissionStatus.state === "denied") {
            console.log("denied state");
            $(".error_popupbg").show();
            $(".textp").text(
              textmapping("Please give permission to camera", props.lang)
            );
            setCamera(false);
            setShowCameraError(true);
            setCameraPermissionGranted(false);
          } else if (cameraPermissionStatus.state === "prompt") {
            console.log("prompt state");
            // Camera permission is in prompt state, listen for changes
            cameraPermissionStatus.onchange = function () {
              if (cameraPermissionStatus.state === "granted") {
                // Camera access is granted now
                setCameraPermissionGranted(true);
                setShowCameraError(false);
              } else if (cameraPermissionStatus.state === "denied") {
                $(".error_popupbg").show();
                $(".textp").text(
                  textmapping("Please give permission to camera", props.lang)
                );
                setCamera(false);
                setShowCameraError(true);
                setCameraPermissionGranted(false);
              }
              // Handle other states if necessary
            };
          }
        })
        .catch(function (error) {
          // Error querying camera permission status
          console.error("Error querying camera permission status:", error);
        });
    } catch (error) {}
  }, []);
  useEffect(() => {
    try {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(function (stream) {
          if (stream) {
            stream.getTracks()?.forEach((track) => track.stop());
          }
        })
        .catch(function (err) {
          $(".error_popupbg").show();
          $(".textp").text(
            textmapping("Please give permission to camera", props.lang)
          );
          setCamera(false);
          setShowCameraError(true);
          setCameraPermissionGranted(false);
          // Permission denied or error occurred
          console.log("Camera permission denied or error:", err);
          // Handle the error or inform the user accordingly
        });
    } catch (error) {}
  }, []);

  return (
    <>
      <ErrorPopup />
      {/* {guidLinePopup && <Popup Close={closeGuidLinePopup} />} */}
      {selectImage && cropModal && (
        <>
          <div className="crop_bg">
            <div className="crop_content">
              <CropperComponent
                lang={props.lang}
                image={selectImage}
                closeCropper={closeCropper}
                getcroppedimage={
                  window.location.pathname == "/uploadimage/effects"
                    ? getCroppedImage
                    : getMonumentCropped
                }
              />
            </div>
          </div>
        </>
      )}

      {/* <img src={CloudImg} /> */}
      <Header lang={props.lang} changeLang={props.changeLang} />
      {pintura && (
        <Pintura
          getFinalPintura={getFinalPintura}
          monumentImage={
            // "https://res.cloudinary.com/" +
            // CloudName +
            // "/image/upload/" +
            props && props.lang == "gu" ? acriveObjM.imgId_gu : acriveObjM.imgId
          }
          userImage={userImageforpintura}
        />
      )}

      {CloudImg && finalResultAry && finalResultAry.length > 0 ? (
        <ImageResult
          shareText={acriveObjM["name"]}
          lang={props.lang}
          finalResultAry={finalResultAry}
          CloudImg={CloudImg}
          CloudTitle={CloudTitle}
          Backbutton={Backbutton}
          imageId={imageId}
          imageDate={imageDate}
          imageDownloadUrl={imageDownloadUrl}
        />
      ) : window.location.pathname == "/uploadimage/effects" ? (
        <>
          <section className="upload_section">
            <div className="container">
              <div className="wall_content_container">
                <div className="selectimage_bg">
                  <NavLink to={"/" + window.location.search} className="">
                    <img
                      src="/assets/images/backarrowbg.svg"
                      className="mobile_back"
                      alt=""
                    />
                    <img
                      src="/assets/images/backarrow.svg"
                      className="desk_back"
                      alt=""
                    />
                  </NavLink>
                  <h4 className="text-center">Choose Face Effects</h4>
                  <p className="text-center">
                    Make your selection from the effects before uploading your
                    picture.
                  </p>
                  <ul className="selectimg_list">
                    {EffectAry &&
                      EffectAry.length > 0 &&
                      EffectAry.map((val, index) => {
                        // console.log("monumnets value ", val);
                        return (
                          <li
                            className={"effectcl effectcl_" + index}
                            onClick={() => {
                              // if (val.type === "facepaint") {
                              //     $(".camera_upload_btn_div").hide();
                              //     setCamera(false);
                              // } else {
                              //     $(".camera_upload_btn_div").show();
                              setCamera(false);
                              // }
                              setActiveEffect(index.toString(), val);
                            }}
                            key={index}
                          >
                            <a>
                              <div className="image_type">
                                <img
                                  src={val.img}
                                  className="user_image"
                                  alt=""
                                />
                                <img
                                  src={val.Effectimg}
                                  className="paint_image"
                                  alt=""
                                />
                              </div>
                            </a>
                            <h5>{val.name}</h5>
                          </li>
                        );
                      })}
                  </ul>

                  <div>
                    <p>
                      {" "}
                      For better experience, please upload a clear image of your
                      torso (above waist), facing the camera.
                      <span
                        className="guidline_span"
                        onClick={() => {
                          setGuidLinePopup(true);
                        }}
                      >
                        Check Detailed Guide
                      </span>
                    </p>
                  </div>
                  {camera && <WebcamCapture handleUpload={handleUpload} />}
                  <div
                    className="upload_div camera_upload_btn_div"
                    id="cameraButton"
                    onClick={() => {
                      if (activeEffects) {
                        setCamera(true);
                      } else {
                        alert("Please select an Effect");
                      }
                    }}
                  >
                    {/* <input
                                            type="file"
                                            onChange={(e) => {
                                                readFile(e);
                                            }}
                                        /> */}
                    <button type="button" className="upload_btn">
                      <img
                        src="/assets/images/upload.svg"
                        className="upload_blue"
                        alt=""
                      />
                      <img
                        src="/assets/images/uploadwhite.svg"
                        className="upload_white"
                        alt=""
                      />
                      Camera
                    </button>
                  </div>
                  <div className="upload_div">
                    <input
                      type="file"
                      onChange={(e) => {
                        if (activeEffects) {
                          readFile(e);
                        } else {
                          alert("Please select an Effect");
                        }
                      }}
                      onClick={(e) => {
                        if (!activeEffects) {
                          alert("Please select an Effect");
                          e.preventDefault();
                        }
                      }}
                      accept="image/jpg, image/jpeg, image/png"
                    />
                    <button type="button" className="upload_btn">
                      <img
                        src="/assets/images/upload.svg"
                        className="upload_blue"
                        alt=""
                      />
                      <img
                        src="/assets/images/uploadwhite.svg"
                        className="upload_white"
                        alt=""
                      />
                      Upload picture
                    </button>
                  </div>

                  <div
                    className="progress progress_div"
                    style={{ display: "none" }}
                  >
                    <div
                      className="progress-bar progress_custom"
                      id="progressBar"
                      style={{ width: "0%" }}
                    >
                      0%
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        !pintura && (
          <>
            <section className="upload_section">
              <div className="container">
                <div className="wall_content_container">
                  <div className="selectimage_bg">
                    <NavLink
                      to={"/" + window.location.search}
                      className="back_btn"
                    >
                      <img
                        src="/assets/images/backarrowbg.svg"
                        className="mobile_back"
                        alt=""
                      />
                      <img
                        src="/assets/images/backarrow.svg"
                        className="desk_back"
                        alt=""
                      />
                    </NavLink>
                    <h4 className="text-center">
                      {textmapping(
                        "Capture a perfect selfie with PM Modi",
                        props.lang
                      )}
                    </h4>
                    <p className="text-center">
                      {textmapping(
                        "Pick your favourite from the images below and click/upload your picture!",
                        props.lang
                      )}
                    </p>
                    <div className="slider_wall monument_div selectimg_list_green">
                      <Slider {...monument}>
                        {monuments &&
                          monuments.map((val, index) => {
                            return (
                              <div key={index}>
                                <div
                                  className={
                                    "monumentcl monument_div monumentcl_" +
                                    index
                                  }
                                  onClick={() => {
                                    setActiveMonument(index.toString(), val);
                                  }}
                                  key={index}
                                >
                                  <div className="image_type_slider">
                                    <img
                                      src={
                                        props && props.lang == "gu"
                                          ? val.imgId_gu
                                          : val.imgId
                                      }
                                      className="user_image"
                                      alt=""
                                    />
                                  </div>
                                  <h5>
                                    {props && props.lang == "gu"
                                      ? val.name_gu
                                      : val.name}
                                  </h5>
                                </div>
                              </div>
                            );
                          })}
                      </Slider>
                    </div>

                    <div style={{ textAlign: "center" }}>
                      <p>
                        {" "}
                        {textmapping(
                          "For better experience, please upload a clear image of your torso and above (above waist), facing the camera",
                          props.lang
                        )}
                      </p>
                    </div>

                    {!userImage ? (
                      <>
                        {/* {camera && (
                          <WebcamCapture handleUpload={handleUpload1} />
                        )}
                        <div
                          className="upload_div"
                          onClick={() => {
                            if (activeMonuments) {
                              setCamera(true);
                            } else {
                              $(".error_popupbg").show();
                              $(".textp").text(
                                textmapping(
                                  "Please select an image",
                                  props.lang
                                )
                              );
                            }
                          }}
                        >
                          {
                            <button type="button" className="upload_btn">
                              <img
                                src="/assets/images/upload.svg"
                                className="upload_blue"
                                alt=""
                              />
                              <img
                                src="/assets/images/uploadwhite.svg"
                                className="upload_white"
                                alt=""
                              />
                              {textmapping("Camera", props.lang)}
                            </button>
                          }
                        </div> */}

                        <div className="upload_div">
                          <input
                            type="file"
                            onChange={(e) => {
                              readFile1(e);
                            }}
                            onClick={(e) => {
                              $('input[type="file"]').val(null);
                              if (!activeMonuments) {
                                $(".error_popupbg").show();
                                $(".textp").text(
                                  textmapping(
                                    "Please select a template",
                                    props.lang
                                  )
                                );
                                // alert(
                                //   textmapping(
                                //     "Please select an image",
                                //     props.lang
                                //   )
                                // );
                                e.preventDefault();
                                return false;
                              }
                            }}
                            accept="image/jpg, image/jpeg"
                          />
                          <button type="button" className="upload_btn">
                            <img
                              src="/assets/images/upload.svg"
                              className="upload_blue"
                              alt=""
                            />
                            <img
                              src="/assets/images/uploadwhite.svg"
                              className="upload_white"
                              alt=""
                            />
                            {textmapping("Upload picture", props.lang)}
                          </button>
                        </div>
                      </>
                    ) : (
                      <div
                        className="upload_div"
                        onClick={() => {
                          Next();
                        }}
                      >
                        <button type="button" className="upload_btn">
                          <img
                            src="/assets/images/upload.svg"
                            className="upload_blue"
                            alt=""
                          />
                          <img
                            src="/assets/images/uploadwhite.svg"
                            className="upload_white"
                            alt=""
                          />
                          {textmapping("Next", props.lang)}
                        </button>
                      </div>
                    )}

                    <div
                      className="progress progress_div"
                      style={{ display: "none" }}
                    >
                      <div
                        className="progress-bar progress_custom"
                        id="progressBar"
                        style={{ width: "0%" }}
                      >
                        0%
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </>
        )
      )}

      {showModal && (
        <UploadedImage
          lang={props.lang}
          src={selectedImage}
          selectedInput={selectedInput}
          submitEffect={
            effectType && effectType === "Monuments"
              ? getMonumentCropped
              : getCroppedImage
          }
          type={effectType}
          close={closeModal}
          rotateImage={rotateImage}
          showCropper={showCropper}
        />
      )}
    </>
  );
};

export default UploadImage;
